import React from "react";
import Button from "@ls/react-button";
import { ThemeProvider } from "styled-components";

const applyTheme = (theme) => {
  return theme;
};

const ThemedButton = (props) => (
  <ThemeProvider theme={applyTheme}>
    <Button {...props} />
  </ThemeProvider>
);

ThemedButton.propTypes = {};

export default ThemedButton;
